import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "@/constants/testIds";

const WHATSAPP_NUMBER = "919820702899";
const PRESET = encodeURIComponent(
  "Hi Aarkays Team, I'd like to talk to an advisor about my financial goals."
);

export default function WhatsAppFAB() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${PRESET}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={WHATSAPP.fab}
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-20 right-5 md:bottom-8 md:right-8 z-50 group"
    >
      <span className="absolute -inset-1 rounded-full wa-pulse"></span>
      <span className="relative flex items-center gap-2 bg-[#25D366] text-white rounded-full pl-3 pr-4 py-3 shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5">
        <span className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
          <MessageCircle className="w-5 h-5" />
        </span>
        <span className="hidden sm:inline text-sm font-medium pr-1">Chat on WhatsApp</span>
      </span>
    </a>
  );
}
